import Vue, { PropType } from 'vue';
import { CellState, IClue } from 'js/crossword/types';
import { IActiveClues } from 'js/crossword/html/ClueColumn';
import { Puzzle } from "../Puzzle";

import styles from "./css/Clue.module.css";

export default Vue.extend({
  computed: {
    active(): boolean {
      return this.activeClues.main === this.clue.id;
    },
    activeSecond(): boolean {
      return this.activeClues.second === this.clue.id;
    },
  },
  props: {
    puzzle: Puzzle,
    clue: Object as PropType<IClue>,
    activeClues: Object as PropType<IActiveClues>,
    hidden: Boolean,
  },
  methods: {
    handleClick() {
      this.$emit('clueClicked', this.clue.id);
    },
  },
  render() {
    const { filled, error } = getClueState(this.puzzle, this.clue);
    const autocheckError = this.puzzle.data.autocheck && error;

    return (
      <div class={{
        [styles.clueContainer]: true,
        [styles.clueContainer_highlight]: this.active,
      }} onClick={this.handleClick}>
        <div class={{
          [styles.secondaryHighlight]: true,
          [styles.secondaryHighlight_invisible]: !this.activeSecond,
        }}></div>
        <div class={{
          [styles.number]: true,
          [`${styles.filled} ${styles.striketrough}`]: filled && !autocheckError,
          [styles.error]: filled && autocheckError,
        }}>{this.clue.identifier || this.clue.number}</div>
        <div class={{
          [styles.text_masked]: this.hidden,
          [styles.filled]: filled && !autocheckError,
          [styles.error]: filled && autocheckError,
        }}>{this.clue.text}</div>
      </div>
    );
  },
});


function getClueState(puzzle: Puzzle, clue: IClue): { filled: boolean, error: boolean } {
  const cells = puzzle.getCellsForClue(clue);

  return {
    filled: cells.every(cell => cell.letter !== ''),
    error: cells.some(cell => cell.state === CellState.Error),
  };
}
